/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckIcaoSex } from './PaxCheckIcaoSex';
import {
    PaxCheckIcaoSexFromJSON,
    PaxCheckIcaoSexFromJSONTyped,
    PaxCheckIcaoSexToJSON,
    PaxCheckIcaoSexToJSONTyped,
} from './PaxCheckIcaoSex';
import type { PaxCheckIcaoNationality } from './PaxCheckIcaoNationality';
import {
    PaxCheckIcaoNationalityFromJSON,
    PaxCheckIcaoNationalityFromJSONTyped,
    PaxCheckIcaoNationalityToJSON,
    PaxCheckIcaoNationalityToJSONTyped,
} from './PaxCheckIcaoNationality';

/**
 * A record of mismatches to booking for document applied
 * @export
 * @interface PaxCheckIdMismatches
 */
export interface PaxCheckIdMismatches {
    /**
     * Given names mismatch - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<string>}
     * @memberof PaxCheckIdMismatches
     */
    givenName?: Array<string> | null;
    /**
     * Last name mismatch - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<string>}
     * @memberof PaxCheckIdMismatches
     */
    surname?: Array<string> | null;
    /**
     * Full name mismatch (for relevant documents, eg Indian E-Visa) - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<string>}
     * @memberof PaxCheckIdMismatches
     */
    fullName?: Array<string> | null;
    /**
     * Document number mismatch - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<string>}
     * @memberof PaxCheckIdMismatches
     */
    number?: Array<string> | null;
    /**
     * Birthdate mismatch - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<Date>}
     * @memberof PaxCheckIdMismatches
     */
    birthdate?: Array<Date> | null;
    /**
     * Sex mismatch - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<PaxCheckIcaoSex>}
     * @memberof PaxCheckIdMismatches
     */
    sex?: Array<PaxCheckIcaoSex> | null;
    /**
     * Nationality mismatch - a pair of (expected, actual); or null if no mismatch on the field
     * @type {Array<PaxCheckIcaoNationality>}
     * @memberof PaxCheckIdMismatches
     */
    nationality?: Array<PaxCheckIcaoNationality> | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckIdMismatches
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckIdMismatches interface.
 */
export function instanceOfPaxCheckIdMismatches(value: object): value is PaxCheckIdMismatches {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckIdMismatchesFromJSON(json: any): PaxCheckIdMismatches {
    return PaxCheckIdMismatchesFromJSONTyped(json, false);
}

export function PaxCheckIdMismatchesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckIdMismatches {
    if (json == null) {
        return json;
    }
    return {
        
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'number': json['number'] == null ? undefined : json['number'],
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'sex': json['sex'] == null ? undefined : ((json['sex'] as Array<any>).map(PaxCheckIcaoSexFromJSON)),
        'nationality': json['nationality'] == null ? undefined : ((json['nationality'] as Array<any>).map(PaxCheckIcaoNationalityFromJSON)),
        'type': json['type'],
    };
}

export function PaxCheckIdMismatchesToJSON(json: any): PaxCheckIdMismatches {
    return PaxCheckIdMismatchesToJSONTyped(json, false);
}

export function PaxCheckIdMismatchesToJSONTyped(value?: PaxCheckIdMismatches | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'given_name': value['givenName'],
        'surname': value['surname'],
        'full_name': value['fullName'],
        'number': value['number'],
        'birthdate': value['birthdate'],
        'sex': value['sex'] == null ? undefined : ((value['sex'] as Array<any>).map(PaxCheckIcaoSexToJSON)),
        'nationality': value['nationality'] == null ? undefined : ((value['nationality'] as Array<any>).map(PaxCheckIcaoNationalityToJSON)),
        'type': value['type'],
    };
}

